import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Trash({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'20px'} height={'22px'} viewBox={'0 0 20 22'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-2.000000, -1.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M3,7 C2.44771525,7 2,6.55228475 2,6 C2,5.44771525 2.44771525,5 3,5 L21,5 C21.5522847,5 22,5.44771525 22,6 C22,6.55228475 21.5522847,7 21,7 L3,7 Z M18,6 C18,5.44771525 18.4477153,5 19,5 C19.5522847,5 20,5.44771525 20,6 L20,20 C20,21.6568542 18.6568542,23 17,23 L7,23 C5.34314575,23 4,21.6568542 4,20 L4,6 C4,5.44771525 4.44771525,5 5,5 C5.55228475,5 6,5.44771525 6,6 L6,20 C6,20.5522847 6.44771525,21 7,21 L17,21 C17.5522847,21 18,20.5522847 18,20 L18,6 Z M9,6 C9,6.55228475 8.55228475,7 8,7 C7.44771525,7 7,6.55228475 7,6 L7,4 C7,2.34314575 8.34314575,1 10,1 L14,1 C15.6568542,1 17,2.34314575 17,4 L17,6 C17,6.55228475 16.5522847,7 16,7 C15.4477153,7 15,6.55228475 15,6 L15,4 C15,3.44771525 14.5522847,3 14,3 L10,3 C9.44771525,3 9,3.44771525 9,4 L9,6 Z M9,11 C9,10.4477153 9.44771525,10 10,10 C10.5522847,10 11,10.4477153 11,11 L11,17 C11,17.5522847 10.5522847,18 10,18 C9.44771525,18 9,17.5522847 9,17 L9,11 Z M13,11 C13,10.4477153 13.4477153,10 14,10 C14.5522847,10 15,10.4477153 15,11 L15,17 C15,17.5522847 14.5522847,18 14,18 C13.4477153,18 13,17.5522847 13,17 L13,11 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Trash.propTypes = {
  className: PropTypes.string,
}
